import React, { useEffect, useState, useCallback } from 'react';
import { FiX } from 'react-icons/fi';
import { useApp } from '../context/AppContext';
import { isAdminRole } from '../utils/adminRoles';
import { playNotificationSound } from '../utils/notificationSound';

/**
 * Уведомление админу о завершении сеансов 1С (вручную или по расписанию).
 */
export default function OnecMassShutdownToast() {
  const { state } = useApp();
  const [toast, setToast] = useState(null);

  const isAdmin = isAdminRole(state.user?.role);

  const dismiss = useCallback(() => setToast(null), []);

  useEffect(() => {
    if (!isAdmin) return undefined;
    const sock = typeof window !== 'undefined' ? window.socket : null;
    if (!sock || typeof sock.on !== 'function') return undefined;

    const handler = (payload) => {
      try {
        playNotificationSound(0.35);
      } catch {
        /* noop */
      }
      setToast({
        id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        at: payload?.at,
        success: payload?.success !== false,
        title: String(payload?.title || '1С'),
        message: String(payload?.message || ''),
        processesBefore:
          payload?.processesBefore != null && Number.isFinite(Number(payload.processesBefore))
            ? Number(payload.processesBefore)
            : null,
      });
    };

    sock.on('onec-mass-shutdown-result', handler);
    return () => {
      try {
        sock.off('onec-mass-shutdown-result', handler);
      } catch {
        /* noop */
      }
    };
  }, [isAdmin, dismiss]);

  useEffect(() => {
    if (!toast) return undefined;
    const t = setTimeout(dismiss, 14000);
    return () => clearTimeout(t);
  }, [toast, dismiss]);

  if (!isAdmin || !toast) return null;

  const ok = toast.success;

  return (
    <div
      style={{
        position: 'fixed',
        top: 72,
        right: 16,
        zIndex: 100050,
        maxWidth: 380,
        width: 'calc(100vw - 32px)',
        borderRadius: 16,
        padding: '16px 18px',
        boxShadow: '0 16px 40px rgba(0,0,0,0.35)',
        border: `1px solid ${ok ? 'rgba(34,197,94,0.45)' : 'rgba(248,113,113,0.5)'}`,
        background: ok
          ? 'linear-gradient(145deg, rgba(22,101,52,0.95) 0%, rgba(15,23,42,0.98) 100%)'
          : 'linear-gradient(145deg, rgba(127,29,29,0.95) 0%, rgba(15,23,42,0.98) 100%)',
        color: '#f8fafc',
        animation: 'onecToastIn 0.35s ease-out',
      }}
    >
      <style>{`
        @keyframes onecToastIn {
          from { transform: translateX(110%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: 'flex-start' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 800, fontSize: 15, marginBottom: 6, letterSpacing: 0.02 }}>
            {ok ? 'Сеансы 1С завершены' : 'Завершение 1С'}
          </div>
          <div style={{ fontSize: 13, opacity: 0.92, fontWeight: 600, marginBottom: 8 }}>{toast.title}</div>
          <div style={{ fontSize: 14, lineHeight: 1.45, opacity: 0.95 }}>{toast.message}</div>
          {toast.processesBefore != null ? (
            <div
              style={{
                marginTop: 10,
                padding: '8px 10px',
                borderRadius: 10,
                background: 'rgba(0,0,0,0.25)',
                fontSize: 13,
                fontWeight: 700,
              }}
            >
              Процессов клиента 1С до операции: {toast.processesBefore}
            </div>
          ) : null}
        </div>
        <button
          type="button"
          aria-label="Закрыть"
          onClick={dismiss}
          style={{
            flexShrink: 0,
            border: 'none',
            background: 'rgba(255,255,255,0.12)',
            color: '#fff',
            borderRadius: 10,
            padding: 8,
            cursor: 'pointer',
            display: 'flex',
          }}
        >
          <FiX size={20} />
        </button>
      </div>
    </div>
  );
}
